/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ComponentsButtonComponent = {
  id?: number
  title?: string
  url?: string
  style?: ComponentsButtonComponent.style
}
export namespace ComponentsButtonComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    ACCENT = 'Accent',
  }
}
